export enum Preference {
  LEFT = -1,
  EITHER = 0,
  RIGHT = 1,
}

type Comparator<T> = (left: T, right: T) => Preference;

export function composeComparator<T>(comparators: Array<Comparator<T>>): Comparator<T> {
  if (!comparators.length) {
    throw Error('Cannot build a well-defined comparator out of an empty array.');
  }
  return (left: T, right: T) => {
    for (const comparator of comparators) {
      const comparisonResult = comparator(left, right);
      if (comparisonResult !== Preference.EITHER) {
        return comparisonResult;
      }
    }
    return Preference.EITHER;
  };
}

export function toComparator<T>(
  scoringFunction: (scorable: T) => number,
  dir: 'max' | 'min' = 'max',
): (left: T, right: T) => Preference {
  return (left, right) => {
    const leftScore = scoringFunction(left);
    const rightScore = scoringFunction(right);
    return compare(leftScore, rightScore, dir);
  };
}

function compare<T extends string | number>(left: T, right: T, dir: 'max' | 'min') {
  if (left === right) {
    return Preference.EITHER;
  }
  if (dir === 'max') {
    return left > right ? Preference.LEFT : Preference.RIGHT;
  } else {
    return left > right ? Preference.RIGHT : Preference.LEFT;
  }
}
